export const more = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="4"
    viewBox="0 0 16 4"
  >
    <g
      id="More_-_Tables"
      data-name="More - Tables"
      style={{ mixBlendMode: 'normal', isolation: 'isolate' }}
    >
      <g id="dots" transform="translate(-119)">
        <path
          id="Path"
          d="M2,4A2,2,0,1,0,0,2,2.006,2.006,0,0,0,2,4Z"
          transform="translate(135) rotate(90)"
          fill="#fff"
        />
        <path
          id="Path-2"
          data-name="Path"
          d="M2,0A2,2,0,1,0,4,2,2.006,2.006,0,0,0,2,0Z"
          transform="translate(129) rotate(90)"
          fill="#fff"
        />
        <path
          id="Path-3"
          data-name="Path"
          d="M2,0A2,2,0,1,0,4,2,2.006,2.006,0,0,0,2,0Z"
          transform="translate(123) rotate(90)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);
